import React, { useState } from 'react';
import styled from 'styled-components';
import { DefaultWidgetBorder } from '../styles/BordersStyle';
import ColorsConstants from '../../constants/ColorConstants';
import { getZIndexByLayerName, LayerNames } from '../../constants/layers.constants';

const aligns = {
    topLeft: '0px 20px 20px 20px',
    topRight: '20px 0px 20px 20px',
    bottomRight: '20px 20px 0 20px',
    bottomLeft: '20px 20px 20px 0',
};

const defaultProps = {
    align: aligns.bottomLeft,
    position: {
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
    },
    stylesToolTip: {},
};

const ToolTipLight = ({
    align,
    children,
    position,
    text,
    stylesToolTip,
}) => {
    const [isVisible, setVisible] = useState(false);
    const tooltipAlign = aligns[align];

    return (
        <HoverToolTip
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
        >
            <Tooltip
                isVisible={isVisible}
                align={tooltipAlign}
                position={position}
                stylesToolTip={stylesToolTip}
            >
                {text}
            </Tooltip>
            {children}
        </HoverToolTip>
    );
};

ToolTipLight.defaultProps = defaultProps;

const HoverToolTip = styled.div`
     position: relative;
`;

const Tooltip = styled.div`
    ${DefaultWidgetBorder};
    background: ${ColorsConstants['catskill-white']};
    border-radius: ${({ align = aligns.bottomLeft }) => align};
    bottom: ${({ position }) => position.bottom};
    color:${ColorsConstants['regal-blue']};
    font-weight: 400;
    left: ${({ position }) => position.left};
    line-height: 1;
    padding: 2px 8px;
    position: absolute;
    right: ${({ position }) => position.right};
    top: ${({ position }) => position.top};
    visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
    width: auto;
    white-space: nowrap;
    z-index: ${getZIndexByLayerName(LayerNames.CURR_VALUE_1)};    
    ${({ stylesToolTip }) => stylesToolTip};
`;

export default ToolTipLight;
